import {Component, HostListener, Inject, NgZone, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatListItem, MatListModule} from "@angular/material/list";
import {SettingsService} from "../../service/settings.service";
import {NgForOf, NgIf} from "@angular/common";
import {MatLine} from "@angular/material/core";
import {translation} from "../../translation";

@Component({
  selector: 'app-shortcuts',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatDialogModule, MatListModule, MatListItem, NgIf, NgForOf, MatLine],
  templateUrl: './whats-new.component.html',
  styleUrl: './whats-new.component.scss'
})
export class WhatsNewComponent {

  protected messages;
  protected version;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected settingsService: SettingsService,
    public dialogRef: MatDialogRef<WhatsNewComponent>) {

    this.messages = data.messages;
    this.version = data.version;
  }

    protected readonly translation = translation;
}
